import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from '@app/services/common.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  constructor(private http: HttpClient, private commonService: CommonService) {}

  getUsersList<T>(
    type: number,
    withMembers: boolean = false,
    mobileNumber?: string
  ) {
    let url = `${
      environment.baseAPIUrl
    }/users?type=${type}&withMembers=${withMembers.toString()}`;
    if (mobileNumber) {
      url += `&mobileNumber=` + mobileNumber;
    }
    return this.http.get<T>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }
}
